<div class="main-content d-flex flex-column">
  <div
    class="funnel-container d-flex flex-column justify-content-center align-items-center flex-grow-1"
    >
    @if (showBackButton) {
      <button
        mat-button
        class="back-button position-absolute"
        (click)="goBack()"
        >
        <i class="ri-arrow-left-s-line"></i>
      </button>
    }
    @if (isLogoShown) {
      <div class="logo w-100 d-flex justify-content-center align-items-center">
        <div class="icon"></div>
        <div class="name ms-10">Peech</div>
      </div>
    }
    <div class="position-relative flex-grow-1 d-flex w-100">
      <div
        class="flex-grow-1 d-flex w-100 flex-column align-items-center"
        [@routeAnimations]="prepareRoute(outlet)"
        >
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </div>
  </div>
</div>
